export const en = {
  general: {
    home: "Home",
    yes: "Yes",
    no: "No",
    title: "Arbor Service Portal",
    login: "Log in",
    logout: "Log out",
    profile: "Profile",
  },
  register: {
    title: "Registers",
    project: {
      title: "Projects",
      labels: {
        report: "Report",
        contractExpirationDate: "Contract expiration date",
      },
      messages: {
        reportNotAvailable: "Report is not available before you save the project!"
      }
    },
    equipment: {
      title: "Devices",
      labels: {
        model: "Model",
        clientInventoryNumber: "Client inventory No.",
        installationDate: "Installation date",
        deinstallationDate: "Deinstallation date",
        serviceProjectNumber: "Service project No.",
        serviceContractNumber: "Service contract No.",
        projectCode: "Project code",
        saleContractNumber: "Sales contract No.",
        saleDocumentNumber: "Sales document No.",
        saleContractFile: "Sales contract file",
        deviceData: "Device data",
        componentData: "Component data",
        clientData: "Client data",
        manufacturerData: "Manufacturer data",
        serviceContractFile: "Service contract file",
        manufacturerWarrantyExpirationDate: "Manufacturer warranty expiration date",
        manufacturerSupportExpirationDate: "Manufacturer support expiration date",
        warrantyExpirationDate: "Warranty expiration date (Arbor)",
        devicePackage: "Device package",
        installations: "Installations",
        acquisitionDocumentNumber: "Manufacturer delivery note No.",
        acquisitionDocumentFile: "Manufacturer delivery note file",
        acquisitionDocumentDate: "Manufacturer delivery note date",
        orderNumber: "Order No.",
        department: "Department",
        serialNumbers: "Serial numbers",
        inventoryNumbers: "Inventory numbers"
      },
      errors: {
        serialInventoryNumberCountMismatch: "Serial number and inventory number count is not matching!",
        installationDateValidationMessage: "This field is required! Dates must be in ascending order!",
        equipmentStateValidationMessage: "Installation statuses cannot be repeated! After write-off, installations are not possible!",
      },
      messages: {
        confirmSaveDeletePackage: "When uninstalling a device that has attached components, those components will be uninstalled with the same date. Continue?",
        confirmSaveComponentDatesInvalid: "The device’s configuration includes components with installation dates that are not compatible with the device’s uninstallation date! When uninstalling a device that has attached components, those components will be uninstalled with the same date. Continue?",
        confirmCopyInstallations: "Copy the entered installations to all devices?",
        noEquipmentSelected: "No device selected!",
        listUnapprovedDevices: "Only unapproved devices are listed!",
        deviceNotApproved: "This device is not approved, save to approve!",
        deviceNotInstalled: "Device is not installed!",
        serialNumberExists: "There is already a device with this serial number!",
        copyByInventoryNoInstallation: "Copying equipment using inventory numbers is only possible if an installation was created."
      },
      actions: {
        copyInstallations: "Copy installations",
      }
    },
    component: {
      title: "Components",
      labels: {
        chooseDevice: "Choose a device",
        deviceData: "Device data",
      },
      messages:{
        confirmCopyInstallations: "Copy the entered installations to all components?",
        listUnapprovedComponents: "Only unapproved devices are listed!",
        componentNotApproved: "This component is not approved, save to approve!",
        componentNotInstalled: "Component is not installed!",
        serialNumberExists: "There is already a component with this serial number!",
        confirmImportMissingInstallations: "At least one device is missing installations. Continue?"
      }
    },
    serviceAct: {
      title: "Service acts",
      labels: {
        saveAsDraft: "Save as draft",
        branch: "Branch",
        department: "Department",
        callNumber: "Call No.",
        dateTimeArrival: "Arrival date/time",
        dateTimeDeparture: "Departure date/time",
        workIsCompleted: "Work completed",
        workNotCompleted: "Work not completed",
        complaint: "Complaint",
        workDone: "Work done",
        isWorkCompleted: "Is work completed",
        notSubmitted: "Not submitted",
        timeSpent: "Time spent",
        diagnostics: "Diagnostics",
        functionalElectricalTest: "Functional electrical safety test",
        DOCUMENTATION: "Documentation",
        installation: "Installation",
        repairs: "Repairs",
        profilacticMaintenance: "Preventive maintenance",
        training: "Training",
        clientApproval: "Client approval",
        serviceActPrintout: "Service act printout",
        actInformation: "Act information",
        chooseEngineer: "Choose engineer",
        usedPartsAndInstruments: "Used spare parts and instruments",
        neededPartsAndInstruments: "Required spare parts and instruments",
        contractNumber: "Contract No.",
        conclusionRemarks: "Conclusion/remarks",
        signature: "Signature",
        engineers: "Engineers",
        newEquipment: "New device/component",
        reviewPrintOut: "Review service act printout",
        isReviewed: "Reviewed",
        clientInformation: "Client information",
        isClientUnknown: "Client is unknown",
        printSignatureFields: "Print signature fields",
        sendForApproval: "Send for approval",
        sentForApproval: "Sent for approval",
        maintenanceConfig: "Maintenance configuration",
        maintenanceCycle: "Maintenance cycle",
        addNewMaintenanceCycle: "Add new maintenance cycle",
      },
      actions: {
        addSignature: "Add signature",
        deleteSignature: "Delete signature",
        confirmDeleteSignature: "Are you sure you want to delete the signature?",
        createMaintenance: "Create maintenance",
        setReviewed: "Mark as reviewed",
        setNotReviewed: "Mark as not reviewed",
        viewMaintenanceConfig: "View maintenance configuration", 
      },
      messages: {
        serviceActApprovalSentSuccessfully: "Service act successfully sent for approval!",
        saveToGenerateMaintenances: "Maintenances will be generated once the service act is submitted as work completed.",
        serviceActNotMaintenance: "Maintenances are only generated for service acts of the maintenance type.",
        isWorkCompleted: "Is work completed?",
        confirmSaveNoEquipment: "There are no devices or components linked to this serviceact! Continue?",
        setAsReviewedSuccessfully: "Service act has been successfully set as reviewed!",
        saveBeforeSendingForApproval: "You must save the service act before sending it for approval!",
        saveBeforeReadingPrintOut: "You must save the service act before viewing the printout!",
        awaitingApproval: "Service act is sent for approval.",
        serviceActApproved: "Service act approved! Approved by: {approver}, date/time: {approveDateTime}, comments: {approverComments}",
        serviceActDenied: "Service act denied! Denied by: {approver}, date/time: {approveDateTime}, comments: {approverComments}",
        confirmSendForApproval: "This service act is already approved! After sending, current approval will be deleted. Continue?",
        cannotSendDraftForApproval: "You cannot send a draft to client for approval!",
        confirmSaveAsDraftDeleteApprovals: "After saving as draft, all client approval data and links for approval will be deleted! Continue?",
        sendForApprovalProhibited: "You are not permitted to send service acts for approval!",
        promptCreateMaintenanceImport: "This service act has multiple devices/components. Do you wish to import maintenances for all equipment?",
      },
      errors:{
        timeSpentValidation: "Time must be provided in hours with an increment of half an hour (0.5 hours)!",
      }
    },
    serviceActApproval: {
      title: "Service act approval",
      labels: {
        serviceActRating: "Service act rating",
        approveDate: "Approval/rejection date",
        expireDateTime: "Valid until",
      },
      actions: {
        approve: "Approve",
        deny: "Reject",
        send: "Send",
        resend: "Resend",
      },
      messages: {
        confirmApprove: "Are you sure you want to approve the service act?",
        confirmDeny: "Are you sure you want to reject the service act?",
      }
    },
    call: {
      title: "Call register",
      labels: {
        chooseDevice: "Choose device",
        addComponent: "Add component",
        issue: "Issue",
        callNotificationType: "Notification type",
        completed: "Completed/declined",
        serviceActs: "Service acts",
        costs: "Costs",
        invoiceNumber: "Invoice No.",
      },
      actions: {
        createServiceAct: "Create service act",
        copyCall: "Copy call",
        setCompleted: "Mark as completed",
        removeCompleted: "Mark as not completed"
      },
      messages: {
        copiedToClipboard: "Call successfully copied to clipboard!",
        userModifiedMessage: "Last modified by: {u}",
      },
    },
    maintenance: {
      title: "Maintenances",
      labels: {
        serviceAct: "Service act",
        maintenanceType: "Maintenance type",
        chooseEquipment: "Choose device/component",
        maintenanceRequest: "Maintenance request",
        warranty: "Warranty",
        maintenanceCycle: "Maintenance cycle",
        chooseMaintenance: "Choose maintenance",
        addEquipment: "Choose equipment",
        maintenanceCycleNotAdded: "Maintenance cycle not added",
        maintenanceRequestNotFound: "Maintenance request not found",
      },
      actions: {
        setMaintenanceCycle: "Attach to maintenance cycle",
        removeMaintenanceCycle: "Remove from maintenance cycle",
        chooseMaintenanceCycle: "Choose maintenance cycle",
        chooseEquipment: "Choose equipment",
      },
      messages: {
        equipmentNotAttached: "There is no equipment selected!",
        serviceActHasMultipleEquipment: "The service act has multiple devices/components attached! Please choose manually!",
      }
    },
    maintenanceCycle: {
      title: "Maintenance cycles",
      labels: {
        lastDoneDate: "Last performed",
        plannedDate: "Planned date",
        maintenanceCount: "Number of maintenances performed",
        period: "Period",
        countPeriodFromPlannedDate: "Count from first maintenance date",
        cycleName: "Cycle name",
      },
      actions: {
        addMaintenance: "Add maintenance",
      },
      errors: {
        periodInvalid: "The period must be an integer greater than 0!"
      }
    },
    maintenanceRequest: {
      title: "Maintenance requests",
      labels: {},
    },
  },
  classifier: {
    title: "Classifiers",
    equipmentmodel: {
      title: "Equipment models",
    },
    equipmenttype: {
      title: "Equipment names",
    },
    equipmentcategory: {
      title: "Equipment groups",
    },
    manufacturer: {
      title: "Manufacturers",
      labels: {
        manufacturer: "Manufacturer",
      },
    },
    client: {
      title: "Clients",
      labels: {
        client: "Client",
      },
    },
    enduser: {
      title: "End users",
    },
    profession: {
      title: "Professions",
    },
    person: {
      title: "Persons",
      labels: {
        firstName: "First name",
        lastName: "Last name",
        phone: "Phone number",
        email: "E-mail",
        profession: "Profession",
      },
    },
    template: {
      labels: {
        sharedTemplate: "Shared template",
      },
    },
  },
  administration: {
    title: "Administration",
    administration: {
      title: "Administration",
      labels: {
        passwordCurrent: "Current password",
        passwordNew: "New password",
        passwordConfirm: "Confirm password",
        changePassword: "Change password",
        users: "Users",
        userData: "User data",
        userPermissions: "User permissions",
        userRoles: "User roles",
        role: "Role",
        roles: "Roles",
        rolePermissions: "Role permissions",
      },
    },
    printForm: {
      title: "Print forms",
      labels: {
        parameters: "Parameters",
        settings: "Print settings",
        exportFormat: "Format",
      },
      actions: {
        generatePreview: "Generate preview",
      },
    },
    report: {
      title: "Reports",
    },
  },
  home: {
    labels: {
      notifications: "Notifications"
    },
    notifications: {
      newDevices: "{p} unapproved devices",
      newComponents: "{p} unapproved components",
      newMaintenanceRequests: "{p} maintenance requests"
    }
  },
  common: {
    labels: {
      code: "Code",
      period: "Period (months)",
      name: "Name",
      type: "Type",
      serialNumber: "Serial No.",
      client: "Client",
      endUser: "End user",
      state: "Status",
      comments: "Comments",
      refNumber: "Reference No.",
      active: "Active",
      created: "Created",
      category: "Category",
      date: "Date",
      attachments: "Attachments",
      attachmentsDrop: "or drop files here",
      file: "File",
      fileName: "File name",
      user: "User",
      number: "Number",
      status: "Status",
      baseInformation: "Basic information",
      engineers: "Engineers",
      engineer: "Engineer",
      department: "Department",
      contractNumber: "Contract No.",
      devices: "Devices",
      components: "Components",
      hours: "Hours",
      quantity: "Quantity",
      manufacturer: "Manufacturer",
      device: "Device",
      component: "Component",
      model: "Model",
      clientInventoryNumber: "Client inventory No.",
      contact: "Contact",
      contacts: "Contacts",
      contactInformation: "Contact information",
      id: "Id",
      warranty: "Warranty",
      equipment: "Device/component",
      dateTime: "Date/Time",
      nameSurname: "First name, Last name",
      preview: "Preview",
      email: "E-mail",
      isActive: "Active",
      templates: "Templates",
      editTemplate: "Edit template",
      content: "Content",
      person: "Person",
      userName: "Username",
      password: "Password",
      count: "Count",
      group: "Group",
      columnChooser: "Column chooser",
      userModified: "Last modified by",
      action: "Action",
      auditLog: "Audit log",
      serialNumbers: "Serial numbers",
      manufacturers: "Manufacturers",
      equipments: "Devices/components",
      serviceAct: "Service act",
      startDate: "Start date",
      endDate: "End date",
      minutes: "Minutes",
      salesPerson: "SalesPerson",
      serviceActs: "Service acts",
      calls: "Calls",
      parameters: "Parameters",
      reportResult: "Report",
      passwordChangeRequired: "Password change required",
      draft: "Draft",
      emails: "E-mails",
    },
    actions: {
      save: "Save",
      change: "Change",
      submit: "Submit",
      confirm: "Confirm", 
      saveAsDraft: "Save as draft",
      delete: "Delete",
      back: "Back",
      search: "Search",
      new: "New",
      browse: "Browse",
      download: "Download",
      copyToClipboard: "Copy to clipboard",
      createMaintenance: "Create maintenance",
      createMaintenanceCycle: "Create maintenance cycle",
      createMaintenanceRequest: "Create maintenance request",
      createCall: "Create call",
      createServiceAct: "Create service act",
      add: "Add",
      edit: "Edit",
      create: "Create",
      apply: "Apply",
      cancel: "Cancel",
      chooseDevice: "Choose device",
      chooseComponent: "Choose component",
      copy: "Copy",
      import: "Import",
      export: "Export",
      clearFilters: "Clear filters",
      select: "Select...",
      restoreGridState: "Restore grid settings",
      reload: "Reload",
      view: "View",
      remove: "Remove",
      generate: "Generate"
    },
    messages: {
      saved: "Saved",
      confirmDelete: "The record will be deleted. Continue?",
      deleted: "Deleted",
      noData: "No data",
      passwordChangeRequired: "Password change is required!",
      confirmModified: "The changes you made will be lost if you close this page! Continue?",
      reportNotGenerated: "The report hasn't been generated",
      mustSaveBeforeContinuing: "You must save before doing this action!",
    },
    errors: {
      valueEmpty: "This field is required!",
      requiredFieldsEmpty: "All required fields are not filled!",
      dateInvalid: "The entered value does not match the date/time format!",
      dateTimeInvalid: "The entered value does not match the date/time format!"
    }
  },
  errors: {
    api: {
      INTERNAL_SERVER_ERROR: "Server error",
      VALUE_EXISTS: "Value '{p}' already exists",
      USER_NAME_EMPTY: "Username is required",
      USER_NAME_EXISTS: "Username already exists",
      USER_DISPLAY_NAME_EMPTY: "Display name is required",
      PASSWORD_EMPTY: "Password is required",
      PASSWORD_INVALID: "Password invalid",
      CONFIRM_PASSWORD_EMPTY: "Password confirmation is required",
      PASSWORD_MISMATCH: "Passwords do not match",
      VALUE_EMPTY: "Value '{p}' must be provided!",
      VALUE_INVALID: "Invalid value in field '{p}'!",
      FORBIDDEN: 'Forbidden!',
      undefined: "An error occurred",
      //ServiceAct
      DEPARTURE_TIME_MUST_EXCEED_ARRIVAL_TIME: "Arrival time cannot exceed departure time!",
      USED_PART_NAME_EMPTY: "Used part name is required!",
      NEEDED_PART_NAME_EMPTY: "Needed part name is required!",
      //Equipment
      COMPONENT_INSTALLED_AFTER_EQUIPMENT_DEINSTALLATION_DATE: "The component's installation date is later than the device's specified deinstallation date!",
      INSTALLATION_STATE_REPEATS: "Installation states must not repeat one after another!",
      //Attachments
      ATTACHMENT_GROUP_MISSING: "Attachment type is required!"
    },
  },
};
